module.exports = __webpack_public_path__ + "static/media/xuhaiwei.0c63bb33.png";